<template>
  <article id="AUTO_TOPUP_REGISTRATIONS">
    <div class="container-fixed">
      <p class="offset-top-2 offset-bottom-2" v-html="$t('autotopupregistrations.infotext')"></p>
    </div>
    <VSpinner v-if="isLoading" class="offset-top-1" />
    <div v-else-if="validRows" class="container-fluid grayed-offset">
      <div class="container-fixed">
        <VList :rows="rows" :selected-row="selectedRow" @selected="onSelectionUpdate" @delete="onShowDeletionModal" />
      </div>
    </div>
    <div class="container-fixed">
      <VSearchFormStatus v-bind="searchform" hide-loading />
    </div>
    <div v-if="selectedRow" class="container-fixed">
      <VDetails :row="selectedRow" />
    </div>
    <VDeletionModal v-if="isDeletionModalShown && selectedRow" :auto-top-up-id="selectedRow.id" @close="onHideDeletionModal" @loadData="loadData" />
  </article>
</template>

<script>
import VList from './List';
import VDetails from './Details';
import VDeletionModal from '@/components/AutoTopUpRegistrations/DeletionModal';
import TitleMixin from '@/mixins/title';
import VSpinner from '@/components/Spinner';
import Proxy from '@/proxies/AutoTopUpRegistrationsProxy';
import SearchFormMixin from '@/mixins/searchform';
import { AUTO_TOPUP_REGISTRATIONS, AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS } from '@/router/route-types';

export default {
  name: 'AutoTopupRegistrations',

  components: {
    VSpinner,
    VList,
    VDetails,
    VSearchFormStatus: () => import('@/components/SearchFormStatus'),
    VDeletionModal,
  },

  mixins: [TitleMixin, SearchFormMixin],

  data() {
    return {
      isLoading: true,
      rows: null,
      autoTopupRegistrationsProxy: new Proxy(),
      selectedRow: null,
      isDeletionModalShown: false,
    };
  },

  computed: {
    validRows() {
      return this.rows && this.rows.length;
    },

    routeParamsAutoTopUpId() {
      return this.$route.params.autoTopUpId;
    },
  },

  watch: {
    routeParamsAutoTopUpId: 'onAutoTopUpIdChanged',
  },

  async created() {
    return this.loadData();
  },

  methods: {
    onAutoTopUpIdChanged(val) {
      if (!val || !this.rows) {
        this.selectedRow = null;
        this.onSelectionUpdate(null);
        return;
      }

      const autoTopUpId = parseInt(val, 10);
      const index = this.rows.findIndex(row => row.id === autoTopUpId);
      if (index < 0) {
        this.selectedRow = null;
        this.onSelectionUpdate(null);
      } else {
        this.selectedRow = this.rows[index];
      }
    },

    onSelectionUpdate(row) {
      const getOverviewDetailsRoute = id => {
        return {
          name: AUTO_TOPUP_REGISTRATIONS_OVERVIEW_DETAILS,
          params: {
            autoTopUpId: id,
          },
        };
      };

      if (!row) {
        this.$router.push({ name: AUTO_TOPUP_REGISTRATIONS }).catch(() => {});
      } else {
        this.$router.push(getOverviewDetailsRoute(row.id)).catch(() => {});
      }
    },

    onShowDeletionModal(row) {
      this.onSelectionUpdate(row);
      this.isDeletionModalShown = true;
    },

    onHideDeletionModal() {
      this.isDeletionModalShown = false;
    },

    async loadData() {
      await this.autoTopupRegistrationsProxy
        .list()
        .then(result => {
          this.rows = result;
          if (this.rows.length === 0) {
            this.searchErrorNoData();
          } else {
            this.searchSuccess();
          }
        })
        .catch(() => {
          this.rows = null;
          this.searchErrorMessage(this.$t('common.errorDefault'));
        })
        .finally(() => {
          if (this.routeParamsAutoTopUpId) {
            this.onAutoTopUpIdChanged(this.routeParamsAutoTopUpId);
          }
          this.isLoading = false;
        });
    },
  },
};
</script>
